const initState = {
  topics: [],
};

const topicsReducers = (state = initState, action) => {
  switch (action.type) {
    case "GET_TOPICS":
      return {
        ...state,
        topics: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default topicsReducers;
